import type { FC } from 'react';
import { useParams } from 'react-router-dom';

import { Page } from '@web/components/Page/Page';
import { SlabTabBar } from '@web/components/SlabTabView/SlabTabBar';
import { useSlabQuery } from '@web/hooks/useSlabQuery';

import { IntegrationsPage } from '../Integrations/IntegrationsPage';
import { TenantUsersPage } from './TenantUsersPage';

export const TenantAdminDetails: FC = () => {
  const { tenantID } = useParams<'tenantID'>();
  if (tenantID === undefined) {
    return <div>ERROR</div>;
  }

  const { data } = useSlabQuery('GET tenants as admin', {});
  const tenantName = data?.items.find((t) => t.id === tenantID)?.name ?? '';

  const tabs = [
    { label: 'Users', element: <TenantUsersPage tenantID={tenantID} /> },
    { label: 'Integrations', element: <IntegrationsPage tenantID={tenantID} /> },
  ];

  return (
    <Page
      title={tenantName}
      pathMap={{
        '/_slabstack_staff': 'Admin Portal',
        [`/_slabstack_staff/${tenantID}`]: tenantName,
      }}
    >
      <SlabTabBar tabs={tabs} />
    </Page>
  );
};
